






















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import EditIcon from '@/components/common/UniversalSearch/images/edit-post.vue.svg';
import type { Post, WarRoomPostCommentSearchResult } from '@/types/graphql';
import PostCommentItem from './UniversalSearchResultsPostComment.vue';

@Component<UniversalSearchResultsPost>({
  components: {
    UniversalSearchResultsItem,
    PostCommentItem,
    EditIcon,
  },
})
export default class UniversalSearchResultsPost extends Vue {
  @Prop({ default: false }) removable!: boolean;
  @Prop({ required: true }) item!: { post: Post; comments: Array<WarRoomPostCommentSearchResult> | null };

  get title() {
    return this.item.post.content.title;
  }

  get description() {
    const author = this.item.post.author;
    let name = '';
    if (author.__typename === 'Anonymous') {
      name = author.username;
    } else if (author.__typename === 'Public') {
      name = `${author.firstname} ${author.lastname}`;
    }
    return name ? `Posted by ${name}` : '';
  }
}
